import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core'
import { Form, Input, Select, Upload, Button, Drawer, Checkbox } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { CTAButton } from '../../components'
import { useData } from '../../../../data'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import PropTypes from 'prop-types'

const { Option } = Select

const useStyles = makeStyles(theme => ({
    error: {
        fontSize: 18,
        color: 'red'
    }
}))

/**
 * Drawer component with form inputs to create a new tool.
 * 
 * Fill in all the required fields
 */

const EditTool = ({ visible, close, tool }) => {
    const [error, setError] = useState(null)
    const data = useData()
    const classes = useStyles()
    const [form] = Form.useForm();
    const { promiseInProgress } = usePromiseTracker()
    if (tool == null) { tool = { "name": "", "description": "", "category": "job", "spider_name": "" } }

    useEffect(() => {
        if (visible)
            form.setFieldsValue({
                'name': tool.name,
                'description': tool.description,
                'category': tool.category,
                'type': tool.type,
                'spider_name': tool.spider_name,
                'is_cookies_required': tool.is_cookies_required
            })
        else
            form.resetFields()
    }, [visible])

    const createTool = details => {
        setError(null)
        const tools = data.tools()
        if (!promiseInProgress) {
            trackPromise(
                tools.updateTool(details, tool.id)
                    .then(close)
                    .catch(err => {
                        console.log(err.message)
                        setError("An error occured")
                    })
            )
        }
    }

    // extract file details 
    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e[0];
        }
        return e && e.fileList[0];
    };


    return (
        <Drawer
            visible={visible}
            title="Edit Tool"
            onClose={close}
            placement="right"
            closable={true}
            width={350}
        >
            <Form
                layout="vertical"
                onFinish={createTool}
                form={form}
            >
                <Form.Item label="Name" name="name" rules={[{ required: true, message: 'Tool name is required' }]}>
                    <Input />
                </Form.Item>
                <Form.Item label="Description" name="description" rules={[{ required: true, message: 'Description is required' }]}>
                    <Input.TextArea />
                </Form.Item>
                <Form.Item label="Category" name="category" rules={[{ required: true, message: 'Category is required' }]}>
                    <Select>
                        <Option value="job">Job</Option>
                        <Option value="contact">Lead profile</Option>
                        <Option value="email">Email</Option>
                    </Select>
                </Form.Item>
                <Form.Item label="Is Cookies required" name="is_cookies_required" valuePropName="checked">
                    <Checkbox></Checkbox>
                </Form.Item>
                <Form.Item label="Type" name="type" rules={[{ required: true, message: 'Type is required' }]}>
                    <Select>
                        <Option value="manual">Manual</Option>
                        <Option value="auto">Auto</Option>
                    </Select>
                </Form.Item>

                <Form.Item label="Spider name" name="spider_name" rules={[{ required: true, message: 'Spider name is required' }]}>
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Sample input file"
                    name="sample_input_file"
                    getValueFromEvent={normFile}
                >
                    <Upload
                        name="sample_input_file"
                        accept=".csv"
                        beforeUpload={() => {
                            return false
                        }}
                        multiple={false}
                    >
                        <Button icon={<UploadOutlined />} > Upload input file </Button>
                    </Upload>
                </Form.Item>
                <Form.Item
                    label="Sample output file"
                    name="sample_output_file"
                    getValueFromEvent={normFile}
                >
                    <Upload
                        name="sample_output_file"
                        accept=".csv"
                        beforeUpload={() => {
                            return false
                        }}
                        multiple={false}
                    >
                        <Button icon={<UploadOutlined />} > Upload input file </Button>
                    </Upload>
                </Form.Item>
                <Form.Item>
                    <CTAButton type="submit" loading={promiseInProgress}>Update</CTAButton>
                </Form.Item>

                {
                    error && (
                        <Form.Item >
                            <p className={classes.error}>{error}</p>
                        </Form.Item>
                    )
                }

            </Form>
        </Drawer>
    )
}

EditTool.propTypes = {
    /** Control the visibility of the drawer */
    visible: PropTypes.bool,
    /** Close/Hide the drawer from view */
    close: PropTypes.func,
    /** Tool ID*/
    tool: PropTypes.string,
}


export default EditTool